import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" {...props}><path fill="#FFF" d="M6 10.5V12a6 6 0 116-6h-1.5A4.5 4.5 0 106 10.5z" /></svg>;